<h1 mat-dialog-title>Enable notifications?</h1>
<div mat-dialog-content>
    Get notified about new chat messages, referrals, and matching listings even when you're not on the site.
</div>
<div mat-dialog-actions align="end">
    <button type="button" mat-button (click)="notNow()">
        Not now
    </button>
    <button type="button" cdkFocusInitial mat-button (click)="enable()">
        Enable notifications
    </button>
</div>
